<template>
  <div id="box">
    <div
      id="con1"
      ref="con1"
      :class="{ anim: animate == true }"
      @mouseenter="mEnter"
      @mouseleave="mLeave"
    >
      <p v-for="(item, index) in items" :key="index" class="styles">
        {{ item.time }} {{ item.name }} {{ item.place }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      animate: false,
      lisArr: [0, 1, 2, 3, 4],
      items: [
        //消息列表对应的数组
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过1号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过2号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过3号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过4号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过5号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过6号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过7号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过8号门",
        },
        {
          name: "xxxxxx",
          time: "2022/01/26  11:44",
          place: "通过9号门",
        },
      ],
    };
  },
  mounted() {
    this.timer1 = setInterval(this.scroll, 1000);
  },

  methods: {
    scroll() {
      var allP = document.querySelectorAll(".styles");
      for (let index = 0; index < allP.length; index++) {
        allP[index].className = "styles";
      }

      this.lisArr.forEach((item, i) => {
        allP[item].classList.add(`style${i + 1}`);
      });

      this.lisArr = this.lisArr.map((item) => item + 1);
      if (allP[allP.length - 1].className === "styles style5") {
        this.lisArr = [
          allP.length - 4,
          allP.length - 3,
          allP.length - 2,
          allP.length - 1,
          0,
        ];
      }
      if (allP[allP.length - 1].className === "styles style4") {
        this.lisArr = [allP.length - 3, allP.length - 2, allP.length - 1, 0, 1];
      }
      if (allP[allP.length - 1].className === "styles style3") {
        this.lisArr = [allP.length - 2, allP.length - 1, 0, 1, 2];
      }
      if (allP[allP.length - 1].className === "styles style2") {
        this.lisArr = [allP.length - 1, 0, 1, 2, 3];
      }
      if (allP[allP.length - 1].className === "styles style1") {
        this.lisArr = [0, 1, 2, 3, 4];
      }

      console.log(this.lisArr);

      // this.defLis = this.defLis.map((item) => item + 1);

      // if (this.defLis[4] == this.items.length ) {
      //   this.defLis = [0, 1, 2, 3, 4];
      // }
      // this.defLis.forEach((item, i) => {
      //   allP[item].classList.add(`style${i + 1}`);
      // });

      // setInterval(() => {

      // }, 1000);
      // let con1 = this.$refs.con1;
      // con1.style.top = "-30px";
      // this.animate = !this.animate;
      // var _this = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向

      // document.querySelector().classList.add('uoa')
      // setTimeout(function () {
      //   _this.items.push(_this.items[0]);
      //   _this.items.shift();
      //   con1.style.top = "0px";
      //   _this.animate = !_this.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      // }, 500);
    },
    mEnter() {
      clearInterval(this.timer1);
    },
    mLeave() {
      this.timer1 = setInterval(this.scroll, 1000);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  margin: 0;
  padding: 0;
}

#box {
  width: 16.146vw;
  height: 11.5vh;
  overflow: hidden;
  padding-left: 30px;
  position: absolute;
}
.anim {
  transition: all 0.5s;
}
#con1 p {
  list-style: none;
  width: 75%;
  line-height: 2.3vh;
  height: 3.2vh;
  transition: all 0.5s;
  display: flex;
  justify-content: space-evenly;
  position: absolute;
  bottom: -35px;
  font-size: 12px;
  background: url("../assets/img/list-li.png") no-repeat;
}
.style1 {
  left: 10px;
  top: 5px;
  /* animation-delay: 0.06s; */
}
.style2 {
  left: 20px;
  top: 35px;
  /* animation-delay: 0.12s; */
}
.style3 {
  left: 30px;
  top: 65px;
  /* animation-delay: 0.18s; */
}
.style4 {
  left: 40px;
  top: 95px;
  /* animation-delay: 0.12s; */
}
.style5 {
  left: 60px;
  top: 125px;
  /* animation-delay: 0.06s; */
  transition: opacity 0.5s !important;
  /* opacity: 0; */
}

/* .uoa {
  animation: 1s up;
}

@keyframes up {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
} */
</style>